import {WicketLocaleOverride} from '../wicket-locale-override';

export interface WicketUserDataDictionaryField {
  id: number;
  name: string;
  display_name: string;
  pattern: string;
  is_unique: boolean;
  is_validated: boolean;
  type: 'string' | 'date' | 'integer' | 'enum' | 'boolean';
  status_at_registration?: 'REQUIRED' | 'OPTIONAL' | 'HIDDEN';
  data_values?: string[];
  is_editable_by_user: boolean;
  is_editable_by_admin: boolean;
  application_config: {
    value?: string;
    is_required: boolean;
    application_id: number;
  };
  locale_override: WicketLocaleOverride<'display_name', string>[];
}
